import Vue from 'vue';
import AjaxUtils from "../../util/ajax_utils";
import Store from "../../data/store";
import $ from "jquery";
import * as showdown from 'showdown';


export const ApckAssetEventsSidebar = {
    components: {
    },
    props: {
        imgSrc: {
            default: '/pre-scan/image',
            type: String
        }
    },
    data: function() {
        return {

        };
    },
    methods: {

    },
    mounted: function() {
        let cmp = this;

    },
    watch: {

    },
    template: `
        <apck-panel no-border title="Activity">
            
            <div class="apck-scan-config-sidebar">


            </div>

        </apck-panel>
    `
}